/* global femcare */

femcare.tracking.personalization = {
    init: function() {
        this.trackingUrl = $('body').data('sca-tracking-url');
        if (this.trackingUrl && this.trackingUrl.length) {
            this.sendTrackingData();
        }
    },

    /**
     * Send tracking data.
     */
    sendTrackingData: function() {
        var that = this;
        var data = [];
        $('[data-sca-tracking-data]').each(function() {
            data.push($(this).data('sca-tracking-data'));
        });
        if (data.length > 0) {
            $.ajax({
                type: 'POST',
                url: that.trackingUrl,
                data: 'data=' + encodeURIComponent(data.join('|'))
            });
        }
    }
};
